import React from "react";
import { Outlet } from "react-router-dom";

const ProductDashboardLayout = () => {
    return (
        <Outlet />
    );
};

export default ProductDashboardLayout;
